import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './Copilot.scss';

interface CopilotMarkdownProps {
  content: string;
}

/**
 * Renders an agent answer written in markdown.
 *
 * Uses `react-markdown`, which parses markdown into a React element tree — there is no
 * `dangerouslySetInnerHTML` and no HTML-string injection. It is safe by default: raw HTML
 * embedded in the markdown is not rendered as markup (no `rehype-raw` plugin), so a model
 * cannot emit active content. `remark-gfm` adds GitHub-flavored markdown (tables, task
 * lists, strikethrough, autolinks).
 */
export function CopilotMarkdown({ content }: CopilotMarkdownProps) {
  return (
    <div className="copilot-markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
}
